<template>
    <v-container grid-list-md class="fb-post-create-process">
        <v-layout row wrap>
            <v-flex md10>
                <v-form ref="form_fb_post_process">
                <v-layout align-center row class="pa-0">
                    <v-flex md4>
                        <label class="text-color-vip">Link hoặc ID profile cần cài VIP:</label>
                    </v-flex>
                    <v-flex md8>
                        <v-text-field
                                solo
                                v-model="linkOrId"
                                placeholder="Nhập link hoặc ID cần tăng"
                                required
                        ></v-text-field>
                    </v-flex>
                </v-layout>

                    <!--videoRef-->
                    <v-layout align-center row v-if="videoId">
                        <v-flex offset-md4>
                            <div class="v-sheet theme--light explain">
                                <a href="#videoRef">
                                    <span class="blue_text label-highlight">Video hướng dẫn tạo job</span>
                                </a>
                            </div>
                        </v-flex>
                    </v-layout>

                    <v-layout align-center row>
                        <v-flex md6>
                            <v-flex md12>
                                <label class="text-color-vip">Số lượng like nhỏ nhất cần tăng mỗi bài viết:</label>
                            </v-flex>
                            <v-flex md12>
                                <v-text-field
                                        solo
                                        v-model="amountMin"
                                        type="number"
                                        :min="minMin"
                                        required
                                ></v-text-field>
                            </v-flex>
                        </v-flex>
                        <v-flex md6 >
                            <v-flex md12>
                                <label class="text-color-vip">Số lượng like lớn nhất cần tăng mỗi bài viết</label>
                            </v-flex>
                            <v-flex md12>
                                <v-text-field
                                        solo
                                        v-model="amountMax"
                                        type="number"
                                        :min="amountMin"
                                        required
                                ></v-text-field>
                            </v-flex>

                        </v-flex>
                    </v-layout>

                <v-layout align-center row>
                    <v-flex md6>
                        <v-flex md12>
                            <label class="text-color-vip">Tổng số bài viết cần đăng ký VIP:</label>
                        </v-flex>
                        <v-flex md12>
                            <v-text-field
                                    solo
                                    v-model="noPostVip"
                                    type="number"
                                    required
                            ></v-text-field>
                        </v-flex>
                    </v-flex>
                    <v-flex md6 >
                        <v-flex md12>
                            <label class="text-color-vip">Số lượng bài viết cần tăng trong 1 ngày:</label>
                        </v-flex>
                        <v-flex md12>
                            <v-text-field
                                    solo
                                    v-model="noPost1Day"
                                    type="number"
                                    required
                            ></v-text-field>
                        </v-flex>
                    </v-flex>
                </v-layout>

                <v-layout align-center row class="pa-0">
                    <v-flex md12>
                        <v-card dark color="lime lighten-5" class="">
                            <v-card-text class="ml-5 black--text">
                                <p class="info-account">
                                    Tổng tiền của gói vip sẽ = (Giá tiền order mỗi like) x (Số lượng like lớn nhất mỗi bài) x (Tổng số bài viết đăng ký vip)
                                </p>
                            </v-card-text>
                        </v-card>
                    </v-flex>
                </v-layout>

                <v-layout align-center row>

                    <v-flex md4>
                        <label class="text-color-vip">Giá tiền mỗi tương tác:</label>
                    </v-flex>
                    <v-flex md8>
                        <v-text-field
                                solo
                                v-model="price"
                                type="number"
                                :min="priceMin"
                        ></v-text-field>
                    </v-flex>
                </v-layout>

                <v-layout align-center row>
                    <v-flex offset-md4>
                        <div class="v-sheet theme--light explain">
                            <span class="red_text">{{ notePrice }}</span>
                        </div>
                    </v-flex>
                </v-layout>

                <v-layout align-center row class="mt-2">
                    <v-flex md4>
                        <label class="text-color-vip">Ghi chú:</label>
                    </v-flex>
                    <v-flex md8>
                        <v-textarea
                                solo
                                v-model="notes"
                                placeholder="Nhập nội dung ghi chú về tiến trình của bạn"
                                height="70px"
                        ></v-textarea>
                    </v-flex>
                </v-layout>

                </v-form>

                <v-layout align-center row class="mt-2">
                    <v-flex md12>
                        <v-card :color="COLOR.VIP" height="100px">
                            <v-card-title>
                                <div class="div-total">
                                    <p>
                                        Tổng: <strong>{{totalCoin | currency_init}}</strong> Coin <br>
                                        Bạn sẽ mua vip <strong>{{amountMax}}</strong> Like tổng  <strong>{{ noPostVip }}</strong> Bài với giá <strong class="">{{price | currency_init}}</strong> {{ priceUnit}}
                                    </p>
                                </div>

                            </v-card-title>
                        </v-card>
                    </v-flex>
                </v-layout>

                <v-layout align-center row class="mt-2">
                    <v-flex md12>
                        <v-btn width="100%" height="50px" :color="COLOR.MAIN_COLOR" class="white--text" @click="saveProcess">
                            Tạo tiến trình
                        </v-btn>
                    </v-flex>
                </v-layout>

                <!--video youtube-->
                <v-layout align-center row v-if="videoId" id="videoRef">
                    <v-flex md12>
                        <div class="col-sm-12 mb-n3">
                            <h3 class="text-color">HƯỚNG DẪN SỬ DỤNG</h3>
                        </div>
                        <div class="col-sm-12 mb-n3">
                            <youtube :video-id="videoId" ref="youtube"
                                 @buffering="playing"
                                 @paused="paused"
                                 @ended="paused"
                                 @playing="playing"
                                 width="100%" height="650px">
                            </youtube>
                        </div>
                    </v-flex>
                </v-layout>

            </v-flex>
            <v-flex md2 text_notes>
                <VipLikeMountAttention />
            </v-flex>
        </v-layout>
        <v-overlay :value="overlay">
            <v-progress-circular
                    indeterminate
                    color="info"
            ></v-progress-circular>
        </v-overlay>
    </v-container>


</template>

<script>
    import VipLikeMountAttention from "~/components/vip-like-mount/VipLikeMountAttention";
    import { COLOR, SEEDING } from "~/config/constant";
    import { validURLFb} from "../../common/helper.string";
    import Swal from 'sweetalert2';
    import { FB_GET_PROFILE_ID, VIP_FACE_GET_SEEDING, VIP_LIKE_MOUNT_SAVE_PROCESS, VIP_FACE_CALCULATE } from "~/store/actions.type";
    import $ from 'jquery';

    export default {
        name: "FbPostCreateProcess",
        components: {
          VipLikeMountAttention
        },
        data() {
            return {
                overlay: false,
                // Color chinh
                 COLOR: COLOR,
                 SEEDING: SEEDING,

                //LINK
                linkOrId: "",

                // amount
                amountMin: 40,
                amountMax: 50,
              minMin: 40,

                noPostVip: 10,
                noPost1Day: 2,

              // Gia tien
                price: 200,
                priceUnit: '  coin/ 1 like/ 1 tháng',
                priceMin: 200,
                notePrice: "Giá thấp nhất: 200 coin",


                // Ghi chu
                notes: "",

                // Tong so coin
                totalCoin: 100000,
                totalAmount: 50,

                // Rules

                videoId: '',
                videoStatus: true,
            }
        },

        created() {
            this.customDataFromApi();
        },

        watch: {
          linkOrId(){
            if (validURLFb(this.linkOrId, 'facebook')) {
              this.getPostId();
            }
          },
          noPostVip() {
            this.calculate();
          },
          noPost1Day() {
            this.calculate();
          },
          amountMax() {
            this.calculate();
          },
            price() {
                this.calculate();
            }
        },
        computed: {

        },
        mounted() {
         if ($('.menu-fbvip-buff').parent().attr('aria-expanded') == "false") {
           $('.menu-fbvip-buff').click();
         }
        },
        methods: {
          async getPostId() {
            this.overlay = true;
            let data  =  await this.$store.dispatch(FB_GET_PROFILE_ID, {profile_link: this.linkOrId});
            if (data) {
              this.linkOrId = data;
              this.overlay=false;
            } else {
                this.linkOrId = '';
                this.overlay = false;
                Swal.fire(
                    'Không thể lấy thông tin profile, vui lòng thử lại hoặc liên hệ với admin để giải quyết',
                    '...',
                    'error'
                )
            }

          },
            async customDataFromApi() {
              let data  =  await this.$store.dispatch(VIP_FACE_GET_SEEDING, {seeding_type_id: 11});
              if(data) {
                console.log(data);
                this.amountMin = parseInt(data.min_like);
                this.minMin = parseInt(data.min_like);
                this.amountMax = parseInt(data.max_like);
                this.price = data.fix_coin;
                this.priceMin = data.fix_coin
                this.notePrice = "Giá thấp nhất: " + this.priceMin+ " coin";
                this.calculate();

                  if (data.video) {
                      let videoId = this.youtube_parser(data.video);
                      if (videoId) {
                          this.videoId = videoId;
                      }
                  }
              }
            },

            validateForm() {
              let valid = true;
              // link or ID
              if (this.linkOrId.toString().trim() === '') {
                return {check: false, message: "Vui lòng nhập link bài post"};
              }
              if (this.amountMin === '') {
                return {check: false, message: "Chưa Nhập số lượng like nhỏ nhất"};
              }
              if (this.amountMax === '') {
                return {check: false, message: "Chưa Nhập số lượng like lớn nhất"};
              }

                if (parseInt(this.amountMin) > parseInt(this.amountMax)) {
                    return {check: false, message: "Số lượng like nhỏ nhất và lớn nhất không hợp hệ"};
              }
              if (this.noPostVip < 1) {
                return {check: false, message: "Số lượng bài viết cần tăng trong 1 ngày không hợp hệ"};
              }
              if (this.noPost1Day < 1) {
                return {check: false, message: "Số lượng bài viết trong 1 ngày cần mua Vip không hợp hệ"};
              }

              return {check: valid, message: ""};
            },
            async saveProcess() {
                this.calculate();
                let validateForm = this.validateForm();
                if (validateForm.check) {
                    try {
                        Swal.fire({
                            title: 'Xác nhận',
                            text: "Bạn có chắc chắn muốn tạo tiến trình ",
                            icon: 'warning',
                            showCancelButton: true,
                            confirmButtonColor: '#3085d6',
                            cancelButtonColor: '#d33',
                            confirmButtonText: 'Đồng ý!',
                            cancelButtonText: 'Không'
                        }).then((result) => {
                            if (result.value) {
                                this.overlay = true;
                                this.saveProcessApi();
                            }
                        })
                    } catch (error) {
                        console.log(error);
                    }
                } else {
                    Swal.fire(
                        validateForm.message,
                        '...',
                        'error'
                    )
                }
            },
            getParams() {
                let params = {
                  fb_id: this.linkOrId,
                  min_like: this.amountMin,
                  max_like: this.amountMax,
                  total_post: this.noPostVip,
                  max_post_daily: this.noPost1Day,
                  fix_coin_job: this.price,
                  prices: this.totalCoin,
                  note: this.notes,
                };
                return params;
            },
            async saveProcessApi() {
                let check = await this.$store.dispatch(VIP_LIKE_MOUNT_SAVE_PROCESS, this.getParams());
                if(check) {
                    this.overlay = false;
                    this.$router.go();
                }

            },
            async calculate() {
              let param = {
                seeding_type: 11,
                max_like: this.amountMax,
                total_post: this.noPostVip,
                fix_coin_job: this.price,
                max_post_daily: parseInt(this.noPost1Day)

              };
              let rs = await this.$store.dispatch(VIP_FACE_CALCULATE, param);
              if(rs) {
                this.totalCoin = rs;
              }

            },

            playing() {
                this.videoStatus = false;
            },
            paused() {
                this.videoStatus = true;
            },
            youtube_parser(url) {
                let regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
                let match = url.match(regExp);
                return (match && match[7].length == 11) ? match[7] : false;
            }
        }
    }
</script>

<style lang="scss">
    @import "../../scss/main";
    .fb-post-create-process {
        background-color: $bgMainColor;
        max-width: 100% !important;

        .v-text-field__details{
            display: none;
        }
        .text-color{
            color: $mainColor;
            font-weight: bold;
        }
        .text-color-vip{
            color: $vip;
            font-weight: bold;
        }
        .div-total {
            width: 100%;
            color: white;
            text-align: center;
        }
        .div-cx {
            height: 60px;
            .cx-img {
                cursor: pointer;
                &hover {
                    opacity: 0.8;
                }
            }
            .cxSelected {
                height: 60px;
                width: 60px;
            }
        }
    }
</style>
